var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkippedGraphIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "18px",
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph-stats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mt/molecules/avatar/skip",
    transform: "translate(-8.000000, -11.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph-stats",
    transform: "translate(9.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.4946329 L3.5,7.4946329 C4.10567257,7.49480113 4.65201797,7.13070236 4.885,6.5716329 L7.485,0.456632898 C7.60657001,0.170602943 7.89195801,-0.0108138449 8.20254518,0.000500402045 C8.51313235,0.011814649 8.78456393,0.213515579 8.885,0.507632898 L13.619,15.2326329 C13.7194361,15.5267502 13.9908676,15.7284511 14.3014548,15.7397654 C14.612042,15.7510796 14.89743,15.5696629 15.019,15.2836329 L17.614,8.4176329 C17.846982,7.85856344 18.3933274,7.49446466 18.999,7.4946329 L22.499,7.4946329",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedGraphIcon);
export default __webpack_public_path__ + "static/media/skipped-graph-icon.eed01773.svg";
export { ForwardRef as ReactComponent };